import React from "react";
import './style.scss';
import { image } from "../../Assets";

const WhyChooseus = () =>{
    return(
        <>
        <section className="whychooseus-section">
            <div className="container">
                <div className="row tw-pb-10">
                    <div className="col-sm-3 col-12">
                        <div className="title">
                            <h2>Why Choose Us</h2>  
                        </div>
                    </div>
                    <div className="col-sm-9 col-12">
                        <p>We follow a client-focused, quality-driven approach that ensures every project is handled with precision and transparency. From initial planning to final handover, we emphasize clear communication, careful resource management, and strict adherence to safety standards. By combining modern construction techniques with proven industry practices, we deliver durable, efficient, and cost-effective solutions. Our goal is to make the building process smooth, reliable, and tailored to your vision.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-3 col-md-6 col-12">
                        <div className="content-box" data-aos="fade-up" data-aos-delay="400">
                            <img src={image.industryExperts} alt=""/>
                            <h4>Industry Experts</h4>
                            <p>
                            We bring our professional experiences from the fields of technology, software, construction, and architecture to assist in articulating your concerns and helping you address them.
                            </p>                                
                        </div>                        
                    </div>
                    <div className="col-xl-3 col-md-6 col-12">
                        <div className="content-box" data-aos="fade-up" data-aos-delay="400">
                            <img src={image.cuttingEdgeTech} alt=""/>
                            <h4>Cutting-Edge Technology</h4>
                            <p>
                            We are the frontrunners of the BIM space. We use the latest, fastest and reliable technical tools to tackle your needs.
                            </p>                                
                        </div>                        
                    </div>
                    <div className="col-xl-3 col-md-6 col-12">
                        <div className="content-box"  data-aos="fade-up" data-aos-delay="400">
                            <img src={image.seamlessCollab} alt=""/>
                            <h4>Seamless Collaboration</h4>
                            <p>
                            Our team becomes your team to successfully deliver on your requirements. Our smooth, transparent communication protocol allows for information exchange in real time.
                            </p>                                
                        </div>                        
                    </div>
                    <div className="col-xl-3 col-md-6 col-12 ">
                        <div className="content-box"  data-aos="fade-up" data-aos-delay="400">
                            <img src={image.customSol} alt=""/>
                            <h4>Customise Solutions</h4>
                            <p>
                            We believe that unique issues require unique answers. We use our skill and resources to provide you with solutions most suited to your needs.
                            </p>                                
                        </div>                        
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default WhyChooseus;